import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useCallback, useRef, useImperativeHandle, } from 'react';
import filesize from 'filesize';
import { nanoid } from 'nanoid';
import AttachmentLineIcon from 'remixicon-react/AttachmentLineIcon';
import { useNetwork } from '@tribeplatform/react-sdk/hooks';
import { toast } from '@tribeplatform/react-ui-kit/Toast';
import { useI18n } from '../../i18n';
import { useComposer } from '../hooks';
import { ComposerIconButton } from './ComposerIconButton';
export const AttachmentPickerButton = forwardRef(({ size }, ref) => {
    const intl = useI18n();
    const { onFileUpload } = useComposer();
    const { data: network } = useNetwork();
    const { fileSizeLimit, fileTypesLimit } = (network === null || network === void 0 ? void 0 : network.settings) || {};
    const attachmentInputId = `attachment-input-${nanoid(10)}`;
    const hiddenFileInput = useRef();
    const onAttachmentInputChange = useCallback((event) => {
        if (!event.target.files)
            return;
        const files = Array.from(event.target.files);
        const selectedTooLargeFile = files.some(file => file.size > fileSizeLimit);
        if (selectedTooLargeFile) {
            toast({
                title: intl.$t({
                    id: 'Composer.AttachmentPickerButton.FileTooLargeTitle',
                    defaultMessage: 'File too large',
                }),
                description: intl.$t({
                    id: 'Composer.AttachmentPickerButton.FileTooLargeDescription',
                    defaultMessage: 'Please upload a file that’s less than {file_size_limit}',
                }, { file_size_limit: filesize(fileSizeLimit) }),
                status: 'error',
            });
            return;
        }
        onFileUpload === null || onFileUpload === void 0 ? void 0 : onFileUpload(files, { asAttachment: true });
        event.target.value = '';
    }, [onFileUpload, fileSizeLimit, intl]);
    const open = () => {
        hiddenFileInput.current.click();
    };
    useImperativeHandle(ref, () => ({
        open,
    }));
    if (typeof onFileUpload !== 'function')
        return null;
    return (_jsxs("div", { children: [_jsx(ComposerIconButton, { icon: AttachmentLineIcon, "aria-label": "Attachment", onClick: open, size: size }, void 0), _jsx("input", { onChange: onAttachmentInputChange, id: attachmentInputId, ref: hiddenFileInput, accept: (fileTypesLimit === null || fileTypesLimit === void 0 ? void 0 : fileTypesLimit.join(',')) || undefined, type: "file", className: "hidden", multiple: true }, void 0)] }, void 0));
});
//# sourceMappingURL=AttachmentPickerButton.js.map